<template>
  <div>
    <el-dialog
    :title="titleName"
    :width="dialogWidth"
    :class="dynamicClass"
    class="add-container"
    modal-append-to-body
    append-to-body
    :visible="showDialog"
    @close='closeDialog'
    >
      <slot></slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogBox',
  props: {
    titleName: {
      type: String
    },
    showDialog: {
      default: true,
      type: Boolean
    },
    dialogWidth: {
      type: String,
      default: '500px'
    },
    dynamicClass: {
      type: String
    }
  },
  data () {
    return {

    }
  },
  methods: {
    closeDialog () {
      // this.showDialog = false
      this.$emit('changeShow')
    }
  }
}
</script>

<style lang="stylus">
.el-dialog
  border: 1px solid #2886F2;
.add-container
  .el-dialog__header
    background:#07f
    .el-dialog__title
      color: #fff;
      color 16px
    .el-dialog__headerbtn
      top 8px;
      line-height: 30px;
      font-size: 22px;
      .el-dialog__close
        color: #fff;
  .el-dialog__body
    min-height: 250px;
    padding: 20px;
    background #203051
  .el-dialog__header
    text-align center
    padding: 10px 20px 10px;
</style>
